export default {
  listTitleTable: {
    TICKER: 'TICKER',
    RTD11: 'MARKET CAP',
    ISA3: 'REVENUE (BN.)<br><small>(TTM)</small>',
    ISA20: 'NET PROFIT (BN.)<br><small>(TTM)</small>',
    //FRYQ30: 'NET PROFIT (BN.)<br><small>(FORECAST)</small>',
    ISA22: 'NET PROFIT (BN.)<br><small>(PLAN)</small>',
    RTD21: 'P/E',
    RTD54: 'FORWARD P/E',
    RTD14: 'EPS<br><small>(TTM)</small>',
    RTD53: 'FORWARD EPS',
    RTD7: 'BVPS<br><small>(TTM)</small>',
  },
};
